module.exports = __webpack_public_path__ + "img/交通-选中.8da04b5b.png";